// extracted by mini-css-extract-plugin
export var addButton = "_fp-0";
export var border = "_fp-8";
export var check = "_fp-h";
export var danger = "_fp-6";
export var dropdownContainer = "_fp-1";
export var editModalBody = "_fp-j";
export var footerContainer = "_fp-i";
export var fullWidth = "_fp-a";
export var hide = "_fp-9";
export var icon = "_fp-3";
export var input = "_fp-7";
export var inputFlex = "_fp-b";
export var inputWrapper = "_fp-c";
export var manualFocus = "_fp-5";
export var optionButton = "_fp-4";
export var pillWrapper = "_fp-e";
export var pointer = "_fp-2";
export var showOverflow = "_fp-f";
export var tagsFlex = "_fp-d";
export var xButton = "_fp-g";